/* Manchester · Wishlist nativo — 2026-07-30
   Reemplaza a Zooomy/Wishify (apps desinstaladas, ver
   docs/superpowers/specs/2026-07-30-native-wishlist-design.md).
   Fuente única de verdad: localStorage['mfg_wishlist'] = [{h: handle, t: epoch-ms}] */
(function () {
  'use strict';

  var KEY = 'mfg_wishlist';
  var MAX = 60;

  function read() {
    try {
      var raw = JSON.parse(localStorage.getItem(KEY));
      if (!Array.isArray(raw)) return [];
      return raw.filter(function (e) {
        return e && typeof e.h === 'string' && e.h.length > 0 &&
          typeof e.t === 'number' && isFinite(e.t);
      });
    } catch (e) {
      return [];
    }
  }

  function write(list) {
    try {
      localStorage.setItem(KEY, JSON.stringify(list));
    } catch (e) {
      /* cuota llena o navegación privada: dejamos de persistir pero la UI sigue viva */
    }
    document.dispatchEvent(new CustomEvent('wishlist:change', {
      detail: { list: list, count: list.length }
    }));
  }

  function indexOfHandle(list, handle) {
    for (var i = 0; i < list.length; i++) {
      if (list[i].h === handle) return i;
    }
    return -1;
  }

  var Store = {
    list: function () { return read(); },

    count: function () { return read().length; },

    has: function (handle) { return indexOfHandle(read(), handle) !== -1; },

    add: function (handle) {
      var list = read();
      if (!handle || indexOfHandle(list, handle) !== -1) return list;
      list.push({ h: handle, t: Date.now() });
      list.sort(function (a, b) { return a.t - b.t; });
      while (list.length > MAX) list.shift();
      write(list);
      return list;
    },

    remove: function (handle) {
      var list = read();
      var i = indexOfHandle(list, handle);
      if (i === -1) return list;
      list.splice(i, 1);
      write(list);
      return list;
    },

    toggle: function (handle) {
      if (Store.has(handle)) { Store.remove(handle); return false; }
      Store.add(handle);
      return true;
    }
  };

  window.MFGWishlist = Store;
})();

/* ── Capa de UI: hidratación + click delegado ── */
(function () {
  'use strict';

  var Store = window.MFGWishlist;
  if (!Store) return;

  var SEL = '.mfg-wl-toggle';

  function paint(btn) {
    var handle = btn.getAttribute('data-wl-handle');
    var saved = handle ? Store.has(handle) : false;
    if (saved) { btn.classList.add('is-saved'); } else { btn.classList.remove('is-saved'); }
    btn.setAttribute('aria-pressed', saved ? 'true' : 'false');
    btn.setAttribute('aria-label', saved ? 'Quitar de favoritos' : 'Guardar en favoritos');
  }

  function paintAll() {
    var nodes = document.querySelectorAll(SEL);
    for (var i = 0; i < nodes.length; i++) paint(nodes[i]);
  }

  /* Canal público explícito para consumidores que inyectan HTML server-rendered
     (botones "off") y necesitan pintarlos SÍNCRONAMENTE en el mismo tick, en vez
     de esperar al siguiente frame del MutationObserver de abajo — p. ej. la
     página de favoritos, donde CADA botón inyectado está garantizado guardado.
     Documentado aquí porque es la única API de esta capa que otro IIFE del
     archivo consume directamente (las demás pasan por el evento). */
  Store.paintAll = paintAll;

  function track(eventName, btn) {
    try {
      var price = parseFloat(btn.getAttribute('data-wl-price'));
      if (isNaN(price)) price = 0;
      var item = {
        item_id: btn.getAttribute('data-wl-product-id'),
        item_name: btn.getAttribute('data-wl-title'),
        item_brand: btn.getAttribute('data-wl-brand') || undefined,
        item_category: btn.getAttribute('data-wl-category') || undefined,
        item_variant_id: btn.getAttribute('data-wl-variant-id') || undefined,
        item_handle: btn.getAttribute('data-wl-handle'),
        price: price,
        quantity: 1
      };
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({
        event: eventName,
        ecommerce: {
          currency: 'MXN',
          value: price,
          items: [item]
        }
      });
    } catch (e) { /* analytics nunca debe romper la UI */ }
  }

  /* Delegado en document: el grid de PLP se re-renderiza con filtros y paginación,
     así que los listeners por elemento quedarían muertos. */
  document.addEventListener('click', function (ev) {
    var btn = ev.target.closest ? ev.target.closest(SEL) : null;
    if (!btn) return;
    /* preventDefault es defensivo, no correctivo: en product-block.liquid el botón
       vive DESPUÉS del cierre de </a> del enlace de la card (hermano, no hijo), y
       en el PDP no está dentro de ningún <a>, así que hoy no hay navegación que
       cancelar. Tampoco hay quickbuy que evitar: quickbuy_style en esta tienda es
       "button" (trigger separado, .quickbuy-toggle), no "whole" — el botón nunca
       queda envuelto por un ancestro con esa clase. Se deja preventDefault por si
       el marcado cambia y el botón termina dentro de un <a> o de un elemento con
       otro handler de click en fase de captura. No usamos stopPropagation: este
       listener está en document y corre en fase de burbujeo, así que ya no puede
       cancelar retroactivamente ningún handler de un ancestro; lo único que haría
       es impedir que el evento llegue a window, rompiendo los handlers "click
       afuera para cerrar" de mega-menú/size-guide/dropdowns a nivel window. */
    ev.preventDefault();
    var handle = btn.getAttribute('data-wl-handle');
    if (!handle) return;
    var nowSaved = Store.toggle(handle);
    track(nowSaved ? 'add_to_wishlist' : 'remove_from_wishlist', btn);
  });

  document.addEventListener('wishlist:change', paintAll);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', paintAll);
  } else {
    paintAll();
  }

  /* Repintar cuando el grid se re-renderiza (mismo patrón que
     manchester-img-warmup.js:64). Debounced con rAF para no pelear con el filtrado. */
  if ('MutationObserver' in window) {
    var queued = false;
    new MutationObserver(function (mutations) {
      if (queued) return;
      for (var i = 0; i < mutations.length; i++) {
        if (mutations[i].addedNodes.length) {
          queued = true;
          window.requestAnimationFrame(function () { queued = false; paintAll(); });
          return;
        }
      }
    }).observe(document.body, { childList: true, subtree: true });
  }
})();

/* ── Contador del header ── */
(function () {
  'use strict';

  var Store = window.MFGWishlist;
  if (!Store) return;

  function sync() {
    var els = document.querySelectorAll('.mfg-wl-count');
    var n = Store.count();
    for (var i = 0; i < els.length; i++) {
      els[i].textContent = n > 0 ? String(n) : '';
      if (n > 0) { els[i].removeAttribute('hidden'); }
      else { els[i].setAttribute('hidden', ''); }
    }
  }

  document.addEventListener('wishlist:change', sync);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', sync);
  } else {
    sync();
  }
})();

/* ── Página de favoritos ── */
(function () {
  'use strict';

  var Store = window.MFGWishlist;
  if (!Store) return;

  var CONCURRENCY = 6;
  var grid, empty, loading;

  /* Cache de HTML de cards ya confirmadas vivas (handle -> html). Sobrevive
     entre pasadas de render() para que una re-pintada (p.ej. la disparada
     tras podar un handle muerto) no vuelva a pedir por red las cards que
     ya sabíamos que existían — fix de la tormenta de peticiones abajo. */
  var cardCache = {};

  /* Token de generación: cada render() se identifica con un número
     creciente. La continuación async de un fetch en vuelo comprueba que
     su número siga siendo el vigente antes de pintar o podar nada — si
     una render() más nueva ya arrancó mientras tanto (p.ej. el usuario
     quitó otro item desde esta misma página), la vieja se descarta sin
     efecto en vez de pintar un resultado obsoleto encima del actual. */
  var renderGen = 0;

  /* Candado para la poda en lote. Store.remove() dispara wishlist:change
     de forma SÍNCRONA dentro de write() (ver la primera IIFE de este
     archivo) — sin este candado, cada Store.remove() de la tanda de
     handles muertos re-entraría a render() y lanzaría su propio fetch de
     red sobre toda la lista, independiente y fuera del cupo de
     CONCURRENCY: para T items guardados y D muertos a la vez, hasta D×T
     peticiones contra el storefront. Con el candado, esas re-entradas
     síncronas no hacen nada; sólo se dispara UNA pasada nueva, manual,
     una vez terminada la poda completa. */
  var suppressRender = false;

  function fetchCard(handle) {
    return fetch('/products/' + encodeURIComponent(handle) + '?view=wl-card', {
      credentials: 'same-origin'
    }).then(function (res) {
      /* Sólo un 404 significa "el producto ya no existe" (borrado o
         despublicado) — es la única condición bajo la que podamos el
         handle de forma permanente. Un 5xx, un fallo de red o CORS, etc.
         son fallos temporales desde el punto de vista del usuario: no le
         tocamos su lista guardada por un problema pasajero del servidor,
         se reintenta solo en una pasada futura. */
      if (res.status === 404) return { handle: handle, status: 'dead' };
      if (!res.ok) return { handle: handle, status: 'retry' };
      return res.text().then(function (html) {
        return html
          ? { handle: handle, status: 'ok', html: html }
          : { handle: handle, status: 'retry' };
      });
    })['catch'](function () {
      return { handle: handle, status: 'retry' };
    });
  }

  /* Pool sencillo: como mucho CONCURRENCY peticiones vivas a la vez. */
  function fetchBatch(handles) {
    var results = new Array(handles.length);
    var next = 0;

    function worker() {
      if (next >= handles.length) return Promise.resolve();
      var i = next++;
      return fetchCard(handles[i]).then(function (r) {
        results[i] = r;
        return worker();
      });
    }

    var workers = [];
    for (var w = 0; w < Math.min(CONCURRENCY, handles.length); w++) workers.push(worker());
    return Promise.all(workers).then(function () { return results; });
  }

  function render() {
    if (!grid || suppressRender) return;

    renderGen++;
    var myGen = renderGen;

    /* Store.list() es ascendente por t (orden de guardado) — ese orden es
       load-bearing para la poda MAX-60 en Store.add(), así que NO se toca
       en el store. Lo que el usuario espera ver es lo último guardado
       arriba, así que invertimos aquí, sólo para pintar, sobre la copia
       local (.map ya devuelve un array nuevo; .reverse() no muta lo que
       persiste en localStorage). */
    var handles = Store.list().map(function (e) { return e.h; }).reverse();

    if (!handles.length) {
      grid.innerHTML = '';
      grid.setAttribute('hidden', '');
      grid.removeAttribute('aria-busy');
      loading.setAttribute('hidden', '');
      empty.removeAttribute('hidden');
      return;
    }

    empty.setAttribute('hidden', '');

    var hadPaintedCards = grid.children.length > 0 && !grid.hasAttribute('hidden');
    if (hadPaintedCards) {
      /* Ya había cards visibles de una pasada anterior: no las tapamos con
         "Cargando…" (parpadeo feo). Sólo marcamos el grid ocupado — CSS
         lo atenúa y bloquea el click — mientras revalidamos en segundo
         plano; el usuario ya vio el heart quitarse en tiempo real (lo
         pinta la capa de UI de forma independiente), esto sólo evita que
         la card en sí se vea "abandonada" junto al texto de carga. */
      grid.setAttribute('aria-busy', 'true');
    } else {
      loading.removeAttribute('hidden');
    }

    var toFetch = [];
    for (var h = 0; h < handles.length; h++) {
      if (!Object.prototype.hasOwnProperty.call(cardCache, handles[h])) toFetch.push(handles[h]);
    }

    fetchBatch(toFetch).then(function (freshResults) {
      /* Cachear los 'ok' incondicionalmente, incluso si esta pasada queda
         obsoleta por el chequeo de generación de abajo: un fetch exitoso
         de un producto vivo sigue siendo un dato válido y nos ahorra
         volver a pedirlo en la siguiente pasada. */
      var freshByHandle = {};
      for (var f = 0; f < toFetch.length; f++) {
        var r = freshResults[f];
        freshByHandle[toFetch[f]] = r;
        if (r && r.status === 'ok') cardCache[toFetch[f]] = r.html;
      }

      if (myGen !== renderGen) return; /* una render() más nueva ya tomó el control */

      var html = '';
      var dead = [];

      for (var i = 0; i < handles.length; i++) {
        var handle = handles[i];
        if (Object.prototype.hasOwnProperty.call(cardCache, handle)) {
          html += cardCache[handle];
          continue;
        }
        var result = freshByHandle[handle];
        if (result && result.status === 'dead') dead.push(handle);
        /* si no hay resultado, o es 'retry': fallo temporal, se omite en
           esta pasada sin tocar el storage — como el handle nunca entra a
           cardCache, la próxima pasada (siguiente wishlist:change o carga
           de página) lo reintenta sola. */
      }

      /* Podar todos los handles muertos de esta tanda como UNA sola
         operación: silenciamos nuestra propia reacción a wishlist:change
         mientras Store.remove() dispara el evento por cada uno (la capa de
         UI y el contador del header NO están silenciados — siguen
         reaccionando en vivo a cada remove(), que es el comportamiento
         correcto para ellos). Al terminar, disparamos nosotros mismos UNA
         única render() nueva en vez de dejar que N re-entradas síncronas
         lancen N tandas de fetch independientes. */
      if (dead.length) {
        suppressRender = true;
        for (var d = 0; d < dead.length; d++) Store.remove(dead[d]);
        suppressRender = false;
        render();
        return;
      }

      grid.removeAttribute('aria-busy');
      loading.setAttribute('hidden', '');
      grid.innerHTML = html;
      /* Las cards recién inyectadas traen el botón server-rendered en estado
         "off" (product-block no sabe qué está guardado). En cualquier otra
         página eso se corrige un frame después vía el MutationObserver de la
         capa de UI, pero aquí CADA card en pantalla está garantizado guardada
         — dejarlo al observer produce un flash de un frame de corazones sin
         rellenar. Pintamos síncronamente por el canal explícito en vez de
         esperar el frame del observer; esto también deja de depender de
         MutationObserver para este caso concreto (sigue existiendo para el
         resto del sitio: PLP/carrusel/etc). */
      if (Store.paintAll) Store.paintAll();
      grid.removeAttribute('hidden');
    });
  }

  function init() {
    grid = document.getElementById('mfg-wl-grid');
    if (!grid) return;                    /* no estamos en la página de favoritos */
    empty = document.getElementById('mfg-wl-empty');
    loading = document.getElementById('mfg-wl-loading');
    document.addEventListener('wishlist:change', render);
    render();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
